import React, { useEffect, useContext } from 'react';
import { StateContext, actions } from "../../../state/index";
import { fetchPaymentDetails, fetchPaymentAccounts, fetchProgramConfiguration, validatePayment } from "../../../api/index";
import { loadProgramResources } from "../../../utils/programResources";

import {
  TOKEN_TYPES,
  HTTP_REQUEST_TYPES,
  LOGGING,
} from "../../../utils/enums";
import { HttpRequestException } from "../../../utils/errors";
import { logger, logHttpError } from "../../../utils/logging";

// TODO: refactor into validation flow
export const InitializePaywallFlow = ({children}) => {
  // eslint-disable-next-line no-empty-pattern
  let [applicationState, dispatch] = useContext(StateContext);
  const { configuration } = applicationState;

  useEffect(() => {
    const fetchValidationToken = (paymentId, validationData) => {
      return validatePayment(paymentId, validationData)
        .then(response => response.data)
        .catch(error => {throw HttpRequestException(HTTP_REQUEST_TYPES.VALIDATION_ATTEMPTS, error, LOGGING.EVENTS.VALIDATION_ATTEMPT_FAILED)});
    };

    const fetchPaymentInfo = (paymentId, validationToken) => {
      // TODO: handle payments that are in archived and cancelled states (possibly handle in complete flow)
      return fetchPaymentDetails(paymentId, validationToken)
        .then(response => response.data)
        .catch(error => {throw HttpRequestException(HTTP_REQUEST_TYPES.FETCH_PAYMENT, error, LOGGING.EVENTS.FETCH_PAYMENT_FAILED, {propsByHttpStatus: {
            default: {
              actions: [{
                label: 'Try Again',
                onClick: initializePaywall,
              }]
            },
          }})});
    };

    const loadProgramConfiguration = (programId, validationToken) => {
      return fetchProgramConfiguration(programId, validationToken)
        .then(response => response.data.v2)
        .catch(error => {throw HttpRequestException(HTTP_REQUEST_TYPES.FETCH_PROGRAM_CONFIGURATION, error, LOGGING.EVENTS.FETCH_PROGRAM_CONFIGURATION_FAILED, {propsByHttpStatus: {
            default: {
              actions: [{
                label: 'Try Again',
                onClick: initializePaywall,
              }]
            },
          }})});
    };

    const loadPaymentAccounts = (paymentId, validationToken) => {
      return fetchPaymentAccounts(paymentId, validationToken)
        .then(response => console.log('accounts') || response.data)
        .catch(error => {throw HttpRequestException(HTTP_REQUEST_TYPES.FETCH_PAYMENT_ACCOUNTS, error, LOGGING.EVENTS.FETCH_PAYMENT_ACCOUNTS_FAILED, {propsByHttpStatus: {
            default: {
              actions: [{
                label: 'Try Again',
                onClick: initializePaywall,
              }]
            },
          }})});
    };

    const initializePaywall = async () => {
      const URL = new window.URL(window.location.href);
      const paymentId = URL.pathname.substring(1);
      const queryParams = new URLSearchParams(window.location.search);
      const refId = queryParams.get('refid');
      const lastName = queryParams.get('lastname');

      if(!refId || !lastName) {
        // if any validation data is missing due to missing query string parameters, skip the request to /validationAttempts and display the error modal
        const queryParamsMap = {};
        queryParams.forEach((value, key) => queryParamsMap[key] = value);

        const logData = {
          event: LOGGING.EVENTS.MISSING_QUERY_PARAMS,
          paymentId,
          queryParams: queryParamsMap,
          paywallUrl: window.location.href,
        };

        logger(logData);

        const simulatedHTTPError = HttpRequestException(HTTP_REQUEST_TYPES.VALIDATION_ATTEMPTS, {status: 400}, LOGGING.EVENTS.VALIDATION_ATTEMPT_FAILED);

        dispatch(actions.modals.showHttpErrorModal(configuration, {
          errorType: simulatedHTTPError.errorType,
          serverResponse: simulatedHTTPError.serverResponse,
          propsByHttpStatus: {
            default: {
              actions: [{
                label: 'Try Again',
                onClick: initializePaywall,
              }]
            },
          }
        }));
      }
      else {
        try {

          const fetchedValidatePaymentToken = await fetchValidationToken(paymentId, {refId, lastName});
          const fetchedPayment = await fetchPaymentInfo(paymentId, fetchedValidatePaymentToken.access_token);

          // can fetch program config and accounts concurrently
          const [fetchedProgramConfiguration, fetchedPaymentAccounts] = await Promise.all([loadProgramConfiguration(fetchedPayment.programId, fetchedValidatePaymentToken.access_token), loadPaymentAccounts(fetchedPayment.id, fetchedValidatePaymentToken.access_token)]);

          logger({
            event: LOGGING.EVENTS.VALIDATION_ATTEMPT_SUCCEEDED,
            paymentId,
            programName: fetchedProgramConfiguration.programName,
            programId: fetchedPayment.programId,
          });

          loadProgramResources(fetchedProgramConfiguration);

          dispatch(actions.tokens.setToken(TOKEN_TYPES.VALIDATE_PAYMENT, fetchedValidatePaymentToken));
          dispatch(actions.configuration.updateConfiguration({
            programId: fetchedPayment.programId,
            ...fetchedProgramConfiguration,
          }));
          dispatch(actions.payment.setPayment(fetchedPayment));
          dispatch(actions.accounts.setAccounts(fetchedPaymentAccounts));
        }
        catch (httpRequestException) {
          logHttpError(httpRequestException, applicationState, {event: httpRequestException.event, paymentId, requestData: {refId, lastName}, paywallUrl: window.location.href});
          dispatch(actions.modals.showHttpErrorModal(configuration, {
            errorType: httpRequestException.errorType,
            serverResponse: httpRequestException.serverResponse,
            ...httpRequestException.options,
          }));
        }
      }
    };

    initializePaywall();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (<>{children}</>);
};

export default InitializePaywallFlow;

